module.exports = __webpack_public_path__ + "static/media/h-prepaid.bf892d34.png";